import PiSearchBlock from './pi_search_block'
import PiGasOrder from './pi_gas_order'
import PiStockChart from './pi_stock_chart'
import PiGasPiOrder from './pi_gas_pi_order'

export default {
  modules: {
    PiSearchBlock,
    PiGasOrder,
    PiStockChart,
    PiGasPiOrder
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pi/index.js